(function () {
    angular.module('PWAPoCApp').controller('scanActionModalController', ScanActionModalController);

    ScanActionModalController.$inject = ['$scope', '$windowInstance', '$timeout', 'initialScanValue', 'originalValue', 'type'];

    function ScanActionModalController($scope, $windowInstance, $timeout, initialScanValue, originalValue, type) {

        $scope.scanValue = initialScanValue || '';
        $scope.originalValue = originalValue;
        $scope.type = type;

        $scope.isCheckboxFieldVisible = false;

        $scope.choosedValue;

        let debouncePromise = null;

        $scope.$watch('scanValue', function (newVal, oldVal) {
            if (newVal === oldVal) return;

            if (!$scope.originalValue) return;

            if (debouncePromise) {
                $timeout.cancel(debouncePromise);
            }

            debouncePromise = $timeout(function () {
                $scope.rfidMatching = $scope.scanValue === $scope.originalValue;
            }, 500);
        });

        $timeout(function () {
            var input = document.getElementById('scanInput');
            if (input) {
                input.focus();

                if ($scope.scanValue) {
                    input.select();
                }
            }
        }, 500);

        $scope.close = function () {
            $windowInstance.close(null);
        };

        $scope.approve = function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            $windowInstance.close(
                $scope.choosedValue ? $scope.choosedValue : $scope.scanValue
            );
        };

        $scope.switchView = function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            $scope.rfidMatching = true;
            $scope.isCheckboxFieldVisible = true;
        }
    }
})();